import IAnswer from "core/interfaces/IAnswer";
import { XetuxProduct } from "./Types";

export interface XetuxProductsAnswer extends IAnswer {
    value: XetuxProduct[];
}

const XetuxProductsDefaultValue: XetuxProductsAnswer = { value: [], type: 'xetux-products'};

export default XetuxProductsDefaultValue;